"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vdf = vdf;
function vdf(input) {
    let state = 0;
    let key = '';
    let val = '';
    const objects = [];
    for (let i = 0; i < input.length; ++i) {
        const c = input[i];
        switch (state) {
            case 0: {
                if (/\s/.test(c)) {
                    continue;
                }
                else if (c === '{') {
                    objects.push({});
                    state = 1;
                }
                else {
                    return [];
                }
                break;
            }
            case 1: {
                if (/\s/.test(c)) {
                    continue;
                }
                else if (c === '}') {
                    state = 0;
                }
                else if (c === '"') {
                    key = '';
                    state = 2;
                }
                else {
                    return [];
                }
                break;
            }
            case 2: {
                if (c === '"') {
                    state = 3;
                }
                else {
                    key += c;
                }
                break;
            }
            case 3: {
                if (/\s/.test(c)) {
                    continue;
                }
                else if (c === '"') {
                    val = '';
                    state = 4;
                }
                break;
            }
            case 4: {
                if (c === '"') {
                    objects[objects.length - 1][key] = val;
                    state = 1;
                }
                else {
                    val += c;
                }
                break;
            }
        }
    }
    return objects;
}
